export enum PermissionType {
    read = 1, write = 2, create = 3, update = 4, delete = 5, none = 6
}
export interface IPermission {
  id: number;
  name: string;
  value: PermissionType
}
